import stringify from 'fast-stringify'; // Use fast-stringify instead of default JSON.stringify to get cache key

var serialize = function serialize(args) {
  return stringify(args);
};

export var recomputeSelectorOptions = {
  serialize: serialize
};